export default __webpack_public_path__ + "static/media/timer.9ce4aace.svg";